module.exports = __webpack_public_path__ + "img/tasks.18b1fdc3.svg";